import { Storage } from "@/common/utils/storage";

const RECRUITER_STORAGE_KEY_PREFIX = "recruiter_ref_";
const RECRUITER_EXPIRY_DAYS = 30;

const getStorageKey = (jobId: string) =>
  `${RECRUITER_STORAGE_KEY_PREFIX}${jobId}`;

export const getRecruiterUserIdFromStorage = async (
  jobId: string,
): Promise<string | null> => {
  const stored = await Storage.getItem(getStorageKey(jobId));
  if (!stored) {
    return null;
  }

  try {
    const { userId, expiry } = JSON.parse(stored);
    if (new Date().getTime() > expiry) {
      await Storage.removeItem(getStorageKey(jobId));
      return null;
    }
    return userId;
  } catch {
    await Storage.removeItem(getStorageKey(jobId));
    return null;
  }
};

export const setRecruiterUserIdInStorage = async (
  jobId: string,
  userId: string,
): Promise<void> => {
  const expiry =
    new Date().getTime() + RECRUITER_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  await Storage.setItem(
    getStorageKey(jobId),
    JSON.stringify({ userId, expiry }),
  );
};

export const clearRecruiterUserIdFromStorage = async (
  jobId: string,
): Promise<void> => {
  await Storage.removeItem(getStorageKey(jobId));
};
